/** v-tableFixed
 * 功能描述：el-table 利用sticky实现左右固定
 * 使用范围：el-table
*/
import { addClass, removeClass } from 'element-ui/lib/utils/dom';
import Vue from 'vue';

const watchPosition = function(el, newVal, oldVal) {
    addClass(el, 'column-fixed');
    if(newVal != 'left') {
        addClass(el, 'show-shadow-left');
    }else {
        removeClass(el, 'show-shadow-left');
    }
    if(newVal != 'right') {
        addClass(el, 'show-shadow-right');
    }else {
        removeClass(el, 'show-shadow-right');
    }
};

export default {
    name: 'tableFixed',
    bind(el, binding, vnode) {
        // console.log('bind', el, binding, vnode);

        if(!vnode.componentOptions || vnode.componentOptions.tag !== 'el-table') {
            throw new Error('el-table is not bound！');
        }

        const table = vnode.componentInstance;
        Vue.nextTick(() => {
            var unwatchPositon = table.$watch('scrollPosition', watchPosition.bind(null, el), { immediate: true });
            var unwatchLayout = table.$watch('layout.scrollY', function(newVal, oldVal) {
                if(newVal) {
                    addClass(el, 'have-scroll-bar');
                }else {
                    removeClass(el, 'have-scroll-bar');
                }

                watchPosition(el, table.scrollPosition);
            });

            el['ds-watchs'] = [unwatchPositon, unwatchLayout];
        });
    },
    unbind(el) {
        // console.log('unbind', el);
        if(el['ds-watchs']) {
            el['ds-watchs'].forEach(unwatch => {
                if(unwatch) unwatch();
            });
        }
    }
};
